import React from "react";
import { Button } from "components/ui";

const SubmitLoaderButton = ({
  isDisable = false,
  btnText = "Add",
  rest,
  className,
}) => {
  return (
    <Button
      disabled={isDisable}
      type="submit"
      className={`min-w-16 ${className}`}
      {...rest}
    >
      {isDisable ? (
        <div className="flex justify-center items-center">
          <div className="size-5 animate-spin rounded-full border-2 border-solid border-[#fff] border-t-transparent"></div>
        </div>
      ) : (
        btnText
      )}
    </Button>
  );
};

export default SubmitLoaderButton;
